<div class="summary-container">
  <form [formGroup]="form">
    @if (summaryData) {
      <div>
        <div class="general-data-card">
          <div class="card-header">
            <h3>{{ 'summary.generalData' | translate }}</h3>
          </div>
          <div class="card-content">
            <div class="data-row">
              <span class="label">{{ 'summary.date' | translate }}:</span>
              <span class="value">{{ getFormattedDate() }}</span>
            </div>
            <div class="data-row">
              <span class="label">{{ 'summary.time' | translate }}:</span>
              <span class="value">{{ getFormattedTime() }}</span>
            </div>
            <div class="data-row">
              <span class="label">{{ 'summary.place' | translate }}:</span>
              <span class="value">{{ getCurrentLocationAddress() }}</span>
            </div>

            <div class="status-indicators">
              <div class="status-item" [class.active]="hasInjuries()">
                <mat-icon class="status-icon" [class.checked]="hasInjuries()" [class.unchecked]="!hasInjuries()">
                  {{ hasInjuries() ? 'check' : 'close' }}
                </mat-icon>
                <span>{{ 'injuries.presence' | translate }}</span>
              </div>
              <div class="status-item" [class.active]="hasMaterialDamage()">
                <mat-icon class="status-icon" [class.checked]="hasMaterialDamage()" [class.unchecked]="!hasMaterialDamage()">
                  {{ hasMaterialDamage() ? 'check' : 'close' }}
                </mat-icon>
                <span>{{ 'damage.material.beyond.vehicles' | translate }}</span>
              </div>
              <div class="status-item" [class.active]="hasWitnesses()">
                <mat-icon class="status-icon" [class.checked]="hasWitnesses()" [class.unchecked]="!hasWitnesses()">
                  {{ hasWitnesses() ? 'check' : 'close' }}
                </mat-icon>
                <span>{{ 'witnesses.presence' | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="vehicle-card vehicle-a">
          <div class="vehicle-header">
            <h3>{{ 'summary.vehicleA' | translate }} ({{ summaryData.targa || ('summary.notSpecified' | translate) }})</h3>
          </div>
          <div class="vehicle-content">
            <div class="vehicle-section">
              <h4>{{ 'summary.driver' | translate }}</h4>
              <div class="section-data">
                <div class="data-row">
                  <span class="label">{{ 'summary.name' | translate }}:</span>
                  <span class="value">{{ getDriverName() }}</span>
                </div>
                <div class="data-row">
                  <span class="label">{{ 'summary.surname' | translate }}:</span>
                  <span class="value">{{ getDriverSurname() }}</span>
                </div>
                @if (summaryData.email) {
                  <div class="data-row">
                    <span class="label">{{ 'field.email' | translate }}:</span>
                    <span class="value">{{ summaryData.email }}</span>
                  </div>
                }
                <div class="data-row">
                  <span class="label">{{ 'field.telefono' | translate }}:</span>
                  <span class="value">{{ summaryData.telefono }}</span>
                </div>
              </div>
            </div>

            <div class="vehicle-section">
              <h4>{{ 'summary.vehicleData' | translate }}</h4>
              <div class="section-data">
                <div class="data-row">
                  <span class="label">{{ 'summary.brand' | translate }}:</span>
                  <span class="value">{{ summaryData.brand || ('summary.notSpecified' | translate) }}</span>
                </div>
                <div class="data-row">
                  <span class="label">{{ 'summary.model' | translate }}:</span>
                  <span class="value">{{ summaryData.modelloBus || ('summary.notSpecified.male' | translate) }}</span>
                </div>
                <div class="data-row">
                  <span class="label">{{ 'summary.plate' | translate }}:</span>
                  <span class="value">{{ summaryData.targa || ('summary.notSpecified' | translate) }}</span>
                </div>
              </div>
            </div>

            @if (getVehicleADynamics().length > 0) {
              <div class="vehicle-section">
                <h4>{{ 'summary.accidentDynamics' | translate }}</h4>
                <div class="section-data">
                  <div class="dynamics-list">
                    @for (dynamic of getVehicleADynamics(); track $index; let last = $last) {
                      <span class="dynamic-item">{{ dynamic | translate }}@if (!last) {<span>, </span>}</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        @for (vehicle of getInvolvedVehiclesWithDynamics(); track vehicle.plate; let i = $index) {
          <div class="vehicle-card"
               [ngClass]="getVehicleCardClass(i + 1)">
            <div class="vehicle-header">
              <h3>{{ 'dynamics.vehicle' | translate }} {{ getVehicleLetter(i + 1) }} ({{ vehicle.plate }})</h3>
            </div>
            <div class="vehicle-content">
              @if (hasCounterpartyData(vehicle)) {
                <div class="vehicle-section">
                  <h4>{{ 'section.counterparty' | translate }}</h4>
                  <div class="section-data">
                    @if (vehicle.nome) {
                      <div class="data-row"><span class="label">{{ 'field.nome' | translate }}:</span> {{ vehicle.nome }}</div>
                    }
                    @if (vehicle.cognome) {
                      <div class="data-row"><span class="label">{{ 'field.cognome' | translate }}:</span> {{ vehicle.cognome }}</div>
                    }
                    @if (vehicle.indirizzo) {
                      <div class="data-row"><span class="label">{{ 'field.indirizzoResidenza' | translate }}:</span> {{ vehicle.indirizzo }}</div>
                    }
                    @if (vehicle.telefono) {
                      <div class="data-row"><span class="label">{{ 'field.telefono' | translate }}:</span> {{ vehicle.telefono }}</div>
                    }
                  </div>
                </div>
              }
              @if (vehicle.dynamics.length > 0) {
                <div class="vehicle-section">
                  <h4>{{ 'summary.accidentDynamics' | translate }}</h4>
                  <div class="section-data">
                    <div class="dynamics-list">
                      @for (dynamic of vehicle.dynamics; track $index; let last = $last) {
                        <span class="dynamic-item">{{ dynamic | translate }}@if (!last) {<span>, </span>}</span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (hasWitnesses() && getWitnesses().length > 0) {
          <div class="vehicle-card witnesses-card">
            <div class="vehicle-header">
              <h3>{{ 'witnesses.title' | translate }}</h3>
            </div>
            <div class="vehicle-content">
              @for (witness of getWitnesses(); track $index; let i = $index) {
                <div class="vehicle-section">
                  <h4>{{ getWitnessTitle(i) }}</h4>
                  <div class="section-data">
                    <div class="data-row">
                      <span class="label">{{ 'summary.name' | translate }}:</span>
                      <span class="value">{{ witness.nome || ('summary.notSpecified' | translate) }}</span>
                    </div>
                    <div class="data-row">
                      <span class="label">{{ 'summary.surname' | translate }}:</span>
                      <span class="value">{{ witness.cognome || ('summary.notSpecified' | translate) }}</span>
                    </div>
                    <div class="data-row">
                      <span class="label">{{ 'field.email' | translate }}:</span>
                      <span class="value">{{ witness.email || ('summary.notSpecified' | translate) }}</span>
                    </div>
                    <div class="data-row">
                      <span class="label">{{ 'field.telefono' | translate }}:</span>
                      <span class="value">{{ witness.telefono || ('summary.notSpecified' | translate) }}</span>
                    </div>
                    @if (witness.dichiarazione) {
                      <div class="data-row">
                        <span class="label">{{ 'witnesses.statement' | translate }}:</span>
                        <span class="value">{{ witness.dichiarazione }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
              <!--@if (hasWitnessDocument()) {
                <div class="vehicle-section">
                  <h4>{{ 'witnesses.document.title' | translate }} ({{ getWitnessDocuments().length }})</h4>
                  @for (doc of getWitnessDocuments(); track doc.name) {
                    <div class="data-row">
                      <span class="value">{{ doc.name }}</span>
                    </div>
                  }
                </div>
              }-->
            </div>
          </div>
        }
      </div>
    }

    <div class="action-buttons-container">
      <button mat-raised-button color="primary" (click)="onSubmitSinistro()" class="action-btn submit-btn" [disabled]="isSubmitting || isSubmitted">
        <mat-icon>send</mat-icon>
        <span>{{ 'button.submitClaim' | translate }}</span>
      </button>
    </div>
  </form>
</div>
